import React, { Component } from "react";
import { connect } from "react-redux";
import { Autocomplete, FormLabel, MenuItem, TextField } from "@mui/material";

import getDestinations from "services/destination/destination.service";
import commonUtilities from "utilities/common";
import { withLocalizer } from "utilities/withLocalizer";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import BlockIcon from "@mui/icons-material/Block";
import { CONFIGURATION } from "utilities/configuration";

import "reactjs-popup/dist/index.css";

class Destination extends Component {
    componentDidMount() {
        this.getDestinations();
    }

    getDestinations() {
        let productType = commonUtilities.getProductType(this.props);
        if (productType?.code) {
            this.props.dispatch(
                getDestinations(productType?.code)
            );
        }
    }

    handleData = (event, city) => {
        let { handleStep2Data, onDestinationChange } = this.props;

        let productType = commonUtilities.getProductType(this.props);

        const { destination } = productType;

        destination.code = city ? city.code : "";
        destination.name = city ? city.name : "";
        destination.providerCode = city ? city.providerCode : "";

        handleStep2Data({ ...productType });
        onDestinationChange();
    };

    render() {
        let { citiesMasterData, error } = this.props;
        let productType = commonUtilities.getProductType(this.props);

        if (!productType) return;

        let { destination } = productType;
        let cities = citiesMasterData?.data?.cities
            ? citiesMasterData?.data?.cities || []
            : [];
        let selectPlaceHolder = this.props.localize("qma-select-label");
        let product = productType?.productType?.code;

        const enabled = (cities?.length > 0);

        return (
            <div className={"row form-control-wrapper" + (enabled ? "" : " disabled")}>
                <FormLabel data-testid="label-destination">
                    {this.props.localize("qma-destination")}
                </FormLabel>

                <Autocomplete
                    popupIcon={CONFIGURATION.APPLY_FIELD_ADORNMENT ? (enabled ? <ExpandMoreIcon/>: <BlockIcon/>) : null}
                    data-testid="autocomplete-destination"
                    disabled={!enabled}
                    autoHighlight
                    value={destination?.code ? destination : null}
                    isOptionEqualToValue={(option) =>
                        option.name === destination.name
                    }
                    noOptionsText="Select"
                    onChange={(event, city) => this.handleData(event, city)}
                    options={cities}
                    getOptionLabel={(city) =>
                        city ? `${city.name} ${ (product.toLowerCase()==="cruise") ? "" : "(" + city.providerCode + ")" }` : ""
                    }
                    renderOption={(props, city, index) => (
                        <li {...props} keys={index}>
                            {city.name} {product.toLowerCase()==="cruise" ? "" : "(" + city.providerCode + ")" }
                        </li>
                    )}
                    renderInput={(params) => (
                        <TextField
                            placeholder={selectPlaceHolder}
                            className={(error?.trim().length === 0) ? "formControl" : "errorControl formControl"}
                            {...params}
                        />
                    )}

                />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    citiesMasterData: state.citiesMasterData
});

export default connect(mapStateToProps)(withLocalizer(Destination));